import { render } from "./BusinessCompanyClientsImport.vue?vue&type=template&id=1a621060"
import script from "./BusinessCompanyClientsImport.vue?vue&type=script&lang=js"
export * from "./BusinessCompanyClientsImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__